// extracted by mini-css-extract-plugin
export default {"rating":"xI-z","numberOfStars":"yI-z","count":"zI-z","barGraphSpacing":"AI-z","barGraph":"BI-z"};